import { facturasKeys } from '@/modules/facturas/queries/queryKeys';
import { facturasGlobalesKeys } from '@/modules/facturasGlobales/queries/queryKeys';
import { recepcionPagosKeys } from '@/modules/recepcionPagos/queries/queryKeys';
import { useQueryClient } from '@tanstack/vue-query';
import { onMounted, watch } from 'vue';
import { useCancellationPendingStore } from '../stores/useCancellationPendingStore';

/**
 * @description Extracts and encapsulates global effects associated to the cancellation process.
 * Used primarily to invalidate TanStack Query caches securely on the background once a pending cancellation
 * is either processed successfully or bounces as failed by the polling system.
 */
export function useCancellationEffects() {
  const queryClient = useQueryClient();
  const cancellationStore = useCancellationPendingStore();

  /**
   * Resume any pending cancellations stored in sessionStorage upon application mount.
   * This ensures resilience against page reloads in any module.
   */
  onMounted(() => {
    cancellationStore.initializePollingFromStorage();
  });

  const invalidateQueriesGlobally = () => {
    // Only perform invalidation if a queryClient was successfully injected
    if (queryClient) {
      queryClient.invalidateQueries({ queryKey: facturasKeys.all() });
      queryClient.invalidateQueries({ queryKey: facturasGlobalesKeys.all() });
      queryClient.invalidateQueries({ queryKey: recepcionPagosKeys.all() });
    }
  };

  watch(
    () => cancellationStore.latestSuccessComprobante,
    val => {
      if (val) invalidateQueriesGlobally();
    },
  );

  watch(
    () => cancellationStore.latestFailedComprobante,
    val => {
      if (val) invalidateQueriesGlobally();
    },
  );
}
